/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateSurveySeasonPlanBody } from '../models/ActivateSurveySeasonPlanBody';
import type { CreateDraftPlanBody } from '../models/CreateDraftPlanBody';
import type { CreateSurveySeasonBody } from '../models/CreateSurveySeasonBody';
import type { CreateSurveySeasonSurveyPlanCommentBody } from '../models/CreateSurveySeasonSurveyPlanCommentBody';
import type { SavePlanSurveyItem } from '../models/SavePlanSurveyItem';
import type { SurveySeason } from '../models/SurveySeason';
import type { SurveySeasonSummaryResponse } from '../models/SurveySeasonSummaryResponse';
import type { SurveySeasonSurveyPlanComment } from '../models/SurveySeasonSurveyPlanComment';
import type { SurveySeasonSurveyPlanCommentsResponse } from '../models/SurveySeasonSurveyPlanCommentsResponse';
import type { SurveySeasonSurveyPlanItem } from '../models/SurveySeasonSurveyPlanItem';
import type { SurveySeasonSurveysResponse } from '../models/SurveySeasonSurveysResponse';
import type { UpdateSurveySeasonBody } from '../models/UpdateSurveySeasonBody';
import type { UpdateSurveySeasonStepStatusBody } from '../models/UpdateSurveySeasonStepStatusBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveySeasonService {

    /**
     * Get survey season
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static getSurveySeason(): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create survey season
     * @returns SurveySeason Created
     * @throws ApiError
     */
    public static createSurveySeason({
        requestBody,
    }: {
        requestBody: CreateSurveySeasonBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Update survey season plan note
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static updateSurveySeason({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateSurveySeasonBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveySeason/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reset the survey season workflow (BC Super Admin only)
     * Removes all workflow progress: deletes the survey season and its survey selections, and deletes the linked plan. If the plan has been activated, its current flag is cleared before deletion. Restricted to BC Super Admins.
     * @returns void
     * @throws ApiError
     */
    public static resetSurveySeasonWorkflow({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveySeason/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a draft plan for survey season
     * @returns SurveySeason Created
     * @throws ApiError
     */
    public static createSurveySeasonPlan({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: CreateDraftPlanBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/plan',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update survey season step status
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static updateSurveySeasonStepStatus({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateSurveySeasonStepStatusBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveySeason/{id}/step-status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get surveys for a survey season plan
     * @returns SurveySeasonSurveyPlanItem Success
     * @throws ApiError
     */
    public static getPlanSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<Array<SurveySeasonSurveyPlanItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/surveys',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Save survey decision for a survey season plan
     * @returns SavePlanSurveyItem Success
     * @throws ApiError
     */
    public static savePlanSurveys({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: Array<SavePlanSurveyItem>,
    }): CancelablePromise<Array<SavePlanSurveyItem>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/surveySeason/{id}/surveys',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Activate the survey season draft plan
     * @returns SurveySeason Success
     * @throws ApiError
     */
    public static activateSurveySeasonPlan({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: ActivateSurveySeasonPlanBody,
    }): CancelablePromise<SurveySeason> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/activate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List survey season enable-surveys grouped by job profile with setup statuses
     * @returns SurveySeasonSurveysResponse Success
     * @throws ApiError
     */
    public static getSurveySeasonEnableSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<SurveySeasonSurveysResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/enable-surveys',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export survey season enable-surveys as CSV
     * @returns string Success
     * @throws ApiError
     */
    public static exportSurveySeasonEnableSurveys({
        id,
    }: {
        id: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/enable-surveys/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List comments for a survey season survey plan row
     * @returns SurveySeasonSurveyPlanCommentsResponse Success
     * @throws ApiError
     */
    public static getSurveySeasonSurveyPlanComments({
        id,
        surveySeasonSurveyPlanId,
    }: {
        id: number,
        surveySeasonSurveyPlanId: number,
    }): CancelablePromise<SurveySeasonSurveyPlanCommentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/survey-plans/{surveySeasonSurveyPlanId}/comment',
            path: {
                'id': id,
                'surveySeasonSurveyPlanId': surveySeasonSurveyPlanId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add a comment to a survey season survey plan row
     * @returns SurveySeasonSurveyPlanComment Created
     * @throws ApiError
     */
    public static createSurveySeasonSurveyPlanComment({
        id,
        surveySeasonSurveyPlanId,
        requestBody,
    }: {
        id: number,
        surveySeasonSurveyPlanId: number,
        requestBody: CreateSurveySeasonSurveyPlanCommentBody,
    }): CancelablePromise<SurveySeasonSurveyPlanComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/survey-plans/{surveySeasonSurveyPlanId}/comment',
            path: {
                'id': id,
                'surveySeasonSurveyPlanId': surveySeasonSurveyPlanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Survey season Review & Confirm summary grouped into new / continuing / not-included
     * @returns SurveySeasonSummaryResponse Success
     * @throws ApiError
     */
    public static getSurveySeasonSummary({
        id,
    }: {
        id: number,
    }): CancelablePromise<SurveySeasonSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveySeason/{id}/summary',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Mark the survey refresh workflow complete; clears the season (keeps the activated plan)
     * @returns void
     * @throws ApiError
     */
    public static completeSurveySeason({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveySeason/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
